import { takeUntil } from "rxjs/operators";
import {
  Component,
  OnInit,
  NgZone,
  HostListener,
  ElementRef,
  AfterViewInit,
} from "@angular/core";

import { Store } from "@ngrx/store";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, Subject } from "rxjs";

import * as reducers from "../reducers";
import * as productActions from "./product.actions";

import { ViewportDetector } from "../shared/viewport-detector";
import { SearchComponent } from "./search/search.component";
import { isEmptyObject } from "../util";

import { ProductService } from "./product.service";

import { ProductDetails } from "../shared/interface/product-details";
import { ProductCompare } from "../shared/interface/product-compare";
import { ProductSearchCriteria } from "../shared/interface/product-search-criteria";

import { ProductSort } from "../shared/interface/product-sort";
import { SeoService } from "../shared/service/seo.service";
import { PreviousRouteService } from "../shared/service/previous-route.service";
import * as $ from "jquery";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";

@Component({
  selector: "product",
  templateUrl: "./product.component.html",
  styleUrls: ["./product.component.scss"],
})
export class ProductComponent implements OnInit, AfterViewInit {
  showFilterCol: boolean = false;
  showMainCol: boolean = true;
  showFilterCompareButtons: boolean = true;
  useNormalZIndex: boolean = false;
  layoutType: string;
  hatchOverlayDisplay: string = "none";
  winPageYOffset: number;
  retailInfoLoading$;
  retailInfo$;
  productDetail;
  productFilter$;
  productFilterSuperset$;
  categorySuperset$;
  productFilterGroup$;
  featuredProduct$;
  productDetails$: Observable<ProductDetails[]>;
  productCompare$: Observable<ProductCompare[]>;
  suggestedProduct$;
  productSearchCriteria = {
    page: 1,
    limit: 9,
    locale: "",
  };
  viewportType: string;
  params;
  productFilterSuperset;
  categorySuperset;
  productFilterGroup;
  destroy$: Subject<boolean> = new Subject<boolean>();
  loading$: Observable<boolean>;
  totalProducts$: Observable<number>;
  locale$: Observable<string>;
  productSort$: Observable<ProductSort[]>;
  productSearch$: Observable<string>;
  isFeaturedProductIncludedInCount$: Observable<boolean>;
  locale;
  screenWidth: string;
  isPaging: boolean = false;
  notDirectlyFromProductParams: boolean = false;
  qp;
  isRefreshed: boolean = false;
  isPreviousRouteCompare: boolean = false;

  isMobileReset: boolean = false;
  disableMobileFilterReset: boolean = false;
  isProductDetailsAvailable: boolean = false;
  isSuggestedProductAvailable: boolean = false;
  drTimer;
  startAttachingNotifyMeListenerStart: number;

  constructor(
    private store: Store<reducers.State>,
    private viewportDetector: ViewportDetector,
    private route: ActivatedRoute,
    private router: Router,
    private productService: ProductService,
    private seoService: SeoService,
    private previousRouteService: PreviousRouteService,
    private elRef: ElementRef,
    private translate: TranslateService
  ) {
    this.getScreenWidth();
  }

  ngAfterViewInit() {
    let locale = window.location.pathname.split("/")[1];
    // this.translate.get('cooling_system').subscribe(some=> {
    //   some;
    // })
  }

  ngOnInit() {
    var that = this;
    this.productFilter$ = this.store.select(reducers.getProductFilter);
    this.productFilterGroup$ = this.store.select(
      reducers.getProductFilterGroup
    );
    this.featuredProduct$ = this.store.select(reducers.getProductFeatured);
    this.productDetails$ = this.store.select(reducers.getProductDetails);
    this.productCompare$ = this.store.select(reducers.getProductCompare);
    this.loading$ = this.store.select(reducers.getProductLoading);
    this.totalProducts$ = this.store.select(reducers.getTotalProducts);
    this.retailInfoLoading$ = this.store.select(reducers.getRetailInfoLoading);
    this.retailInfo$ = this.store.select(reducers.getRetailInfo);
    this.suggestedProduct$ = this.store.select(reducers.getSuggestedProduct);
    this.locale$ = this.store.select(reducers.getLocale);
    this.productSort$ = this.store.select(reducers.getProductSort);
    this.productSearch$ = this.store.select(reducers.getProductSearch);
    this.isFeaturedProductIncludedInCount$ = this.store.select(
      reducers.getIsFeaturedProductIncludedInCount
    );
    this.productFilterSuperset$ = this.store.select(
      reducers.getProductFilterSuperSet
    );
    this.categorySuperset$ = this.store.select(reducers.getCategorySuperset);
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      if (params && params.locale) {
        if (
          params.locale === "en-us" ||
          params.locale === "en-gb" ||
          params.locale === "de-de" ||
          params.locale === "fr-fr"
        ) {
          this.locale = params.locale;
          this.productSearchCriteria = Object.assign(
            {},
            this.productSearchCriteria,
            {
              locale: this.locale,
            }
          );
          this.store.dispatch(new productActions.LoadLocale(this.locale));
          this.seoService.generateTags(this.locale, false);
        } else {
          window.location.href = `https://store.nvidia.com/en-us/studio/page-not-found`;
        }
      }
    });

    this.productDetails$.subscribe((productDetails) => {
      productDetails.length
        ? (this.isProductDetailsAvailable = true)
        : (this.isProductDetailsAvailable = false);
    });

    this.suggestedProduct$.subscribe((suggestedProduct) => {
      suggestedProduct && suggestedProduct.productDetails.length
        ? (this.isSuggestedProductAvailable = true)
        : (this.isSuggestedProductAvailable = false);
    });

    this.productFilterSuperset$.subscribe((filters) => {
      filters && filters.length
        ? (this.productFilterSuperset = filters)
        : (this.productFilterSuperset = []);
    });

    this.categorySuperset$.subscribe((obj) => {
      this.categorySuperset = obj;
    });

    this.productFilterGroup$.subscribe((obj) => {
      this.productFilterGroup = obj;
    });
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((queryParams) => {
        if (!this.previousRouteService.getIsFromCompare() && !this.isPaging) {
          let size = Object.keys(queryParams).length;
          let defaultQueryParams = Object.assign({}, queryParams, {
            page: 1,
            locale: this.locale,
          });
          if (size > 3 && !this.isRefreshed) {
            this.store.dispatch(
              new productActions.ClearProductFilterSelection(
                this.productSearchCriteria
              )
            );
            this.store.dispatch(
              new productActions.UpdateProductParamsOnload(defaultQueryParams)
            );
          }
          if (size === 1 && !this.isRefreshed) {
            this.productSearchCriteria = Object.assign(
              {},
              this.productSearchCriteria,
              {
                gpu: queryParams.gpu,
              }
            );
            this.store.dispatch(
              new productActions.UpdateProductParamsOnload(
                this.productSearchCriteria
              )
            );
          }
        }
        if (this.previousRouteService.getIsFromCompare()) {
          this.store.dispatch(
            new productActions.LoadProduct({
              productSearchCriteria: this.productSearchCriteria,
              locale: this.locale,
              productFilterGroup: this.productFilterGroup,
            })
          );
          this.store.dispatch(
            new productActions.UpdateProductParamsOnload(
              this.productSearchCriteria
            )
          );
        }
      });

    function initProductCategories() {
      try {
        let productCategories = JSON.parse(
          localStorage.getItem(getCurLocale() + "-productCategories")
        );
        if (productCategories) {
          return productCategories;
        }
      } catch (e) { }
      return [];
    }

    function getCurLocale(): string {
      return window.location.pathname.split("/")[1];
    }

    const cats = initProductCategories();
    if (!cats.length) {
      let defaultParams = {
        page: 1,
        limit: 9,
        locale: this.locale,
        loadDefault: true,
        isCategoriesSuperset: this.categorySuperset,
      };
      this.store.dispatch(
        new productActions.LoadFilterCategories({
          productSearchCriteria: defaultParams,
          locale: this.locale,
          productFilters: this.productFilterSuperset,
          loadCategories: true,
        })
      );
    }

    this.store
      .select(reducers.getProductParams)
      .subscribe((params: ProductSearchCriteria) => {
        if (!this.previousRouteService.getIsFromCompare()) {
          this.productSearchCriteria = Object.assign({}, params);
          this.isRefreshed = true;
          if (
            this.isMobileReset ||
            !this.showFilterCol ||
            this.screenWidth === "LG" ||
            this.screenWidth === "XL"
          ) {
            this.store.dispatch(
              new productActions.LoadProduct({
                productSearchCriteria: params,
                locale: this.locale,
                productFilterGroup: this.productFilterGroup,
              })
            );
          }
        }
      });

    this.viewportDetector.$viewport.subscribe((viewport) => {
      this.viewportType = viewport;
    });

    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: LangChangeEvent) => {
        setTimeout(() => {
          $(".cart-main-section .cart__empty")[0] &&
            ($(".cart-main-section .cart__empty")[0].innerHTML =
              that.translate.instant("empty_cart"));
          $(".cart-main-section .cart__title")[0] &&
            ($(".cart-main-section .cart__title")[0].innerHTML =
              that.translate.instant("cart"));
          $(".cart-main-section .cart__items").each(function () {
            $(this)
              .find(".cart_remove .cart-item__remove")
              .each(function (i) {
                $(".cart_remove .cart-item__remove")[i].innerHTML =
                  that.translate.instant("remove");
              });
            $(this)
              .find(".cart__promotions")
              .each(function (i) {
                $(".cart_bundle_link")[i] &&
                  ($(".cart_bundle_link")[i].innerHTML =
                    that.translate.instant("included"));
              });
          });
          $(".cart-main-section .cart__checkout-button")[0] &&
            ($(".cart-main-section .cart__checkout-button")[0].innerHTML =
              that.translate.instant("checkout"));
        }, 1000);
      });
  }

  @HostListener("window:resize") onScreenResize() {
    this.getScreenWidth();
    this.drTimer = setTimeout(() => {
      $(".js-product-item").removeData();
      window["hatchwidgetHelpers"].reloadScript();
    }, 700);
  }

  getScreenWidth() {
    if (window.matchMedia("(min-width: 1281px)").matches) {
      this.screenWidth = "XL";
    } else if (window.matchMedia("(min-width: 1025px)").matches) {
      this.screenWidth = "LG";
    } else if (window.matchMedia("(min-width: 768px)").matches) {
      this.screenWidth = "MD";
    } else {
      this.screenWidth = "SM";
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  onFilterChange(event) {
    const payload = JSON.parse(event);
    this.store.dispatch(
      new productActions.LoadProduct({
        productSearchCriteria: payload,
        locale: this.locale,
        productFilterGroup: this.productFilterGroup,
      })
    );
  }

  onPaging(event) {
    this.previousRouteService.setIsFromCompare(false);
    this.isPaging = true;
    const payload = event.value;
    this.productSearchCriteria = Object.assign({}, this.productSearchCriteria, {
      page: payload.page,
    });
    this.store.dispatch(
      new productActions.LoadProduct({
        productSearchCriteria: this.productSearchCriteria,
        locale: this.locale,
        productFilterGroup: this.productFilterGroup,
      })
    );
  }

  onClearFilter(isMobileReset) {
    if (this.disableMobileFilterReset) {
      return;
    }
    if (isMobileReset) {
      this.isMobileReset = true;
    }
    this.previousRouteService.setIsFromCompare(false);
    let clearFilter = {
      page: 1,
      limit: 9,
      locale: this.locale,
    };
    for (var addtionalKey in this.productSearchCriteria) {
      if (addtionalKey === "search" || addtionalKey === "sorting") {
        clearFilter = Object.assign({}, clearFilter, {
          [addtionalKey]:
            this.productSearchCriteria[addtionalKey] !== ""
              ? this.productSearchCriteria[addtionalKey]
              : undefined,
        });
      }
    }
    this.store.dispatch(
      new productActions.ClearProductFilterSelection(clearFilter)
    );
  }

  applyFilter() {
    window.scroll(0, 0);
    this.store.dispatch(
      new productActions.LoadProduct({
        productSearchCriteria: this.productSearchCriteria,
        locale: this.locale,
        productFilterGroup: this.productFilterGroup,
      })
    );
    this.showFilterCol = false;
    this.showMainCol = true;
    this.showFilterCompareButtons = true;
  }

  toggleMobileFilterReset(disabled) {
    if (this.isMobileReset) {
      this.isMobileReset = false;
    } else if (
      (this.screenWidth === "SM" || this.screenWidth === "MD") &&
      this.showFilterCol &&
      disabled
    ) {
      this.onClearFilter(true);
    }
    this.disableMobileFilterReset = disabled;
  }

  onFilterButtonClick(): void {
    window.scroll(0, 0);
    this.showFilterCol = true;
    this.showMainCol = false;
    this.showFilterCompareButtons = false;
  }

  onFilterCloseButtonClick(): void {
    window.scroll(0, 0);
    this.showFilterCol = false;
    this.showMainCol = true;
    this.showFilterCompareButtons = true;
  }

  onCompareOverlayTransitionEnd(event) {
    this.useNormalZIndex = event.useNormalZIndex;
  }

  isQueryParamPresent(queryParams) {
    return isEmptyObject(queryParams);
  }

  isOtherThanDefaultQueryParam(params) {
    return Object.keys(params).length > 3 ? true : false;
  }

  showHatchOverlay(e) {
    this.winPageYOffset = e.winPageYOffset;
    this.productDetail = e.productDetail;
    this.hatchOverlayDisplay = "none";
    setTimeout(() => {
      this.hatchOverlayDisplay = "block";
    }, 10);
  }
}
